import { DocsStoreProvider } from '@modules/docs/providers/DocsStoreProvider';
import { ModalProvider } from 'react-modal-hook';
import { Outlet } from 'react-router';
import { CollaborationContextProvider } from 'src/features/collaboration';
import { ConversationContextProvider } from 'src/provider/ConversationContext';
import { useRoutes } from 'src/services/sentry';
import { SocketProvider } from 'src/socket';
import {
  BoardTableRowDialogPage,
  DocCommentsPickViewPage,
  NewThreadViewPage,
  ThreadViewPage,
} from './elements';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SocketProvider>
      <DocsStoreProvider>
        <CollaborationContextProvider>
          <ModalProvider>{children}</ModalProvider>
        </CollaborationContextProvider>
      </DocsStoreProvider>
    </SocketProvider>
  );
}

export const Modals = () =>
  useRoutes([
    {
      path: '/:accountIndex',
      element: (
        <Providers>
          <Outlet />
        </Providers>
      ),
      children: [
        {
          path: 'boards/:boardId/:tableId/v/:rowId',
          element: (
            <ConversationContextProvider>
              <BoardTableRowDialogPage />
            </ConversationContextProvider>
          ),
        },
        {
          path: 'docs/:docId/comments',
          element: (
            <ConversationContextProvider>
              <DocCommentsPickViewPage />
            </ConversationContextProvider>
          ),
        },
        {
          path: 'chat/:conversationKey/new-thread/:parentMessageId',
          element: <NewThreadViewPage />,
        },
        {
          path: 'chat/:rootConversationKey/thread/:conversationKey',
          element: <ThreadViewPage />,
        },
      ],
    },
  ]);
